// English localisations
export const en = {
    home: {
        'welcome-message': 'Welcome to {name}',
        'select-performance': 'Please select a performance:',
        'back-to-login': 'Back to login',
        'loading-performances': 'Loading performances...',
        'no-performances-available': 'There are currently no performances available',
        'refresh': 'Refresh'
    },
    performance: {
        'not-started': 'The performance has not started yet.',
        'show-previous': 'Show previous',
        'back-to-new': 'Back to new'
    },
    settings: {
        'title': 'Settings',
        'profile': 'profile/language',
        'show-time': 'Show timestamps',
        'show-media': 'Show media',
        'large-text': 'Use large text',
        'new-on-top': 'Show new items on top',
        'display-style': 'Display style',
        'display-inline': 'All items inline',
        'display-sticky': 'Sticky final partition',
        'analytics': 'Analytics',
        'data-warning': 'Entering will send us your usage data',
        'wakelock': 'Keep device awake',
        'text-size': 'Font size',
        'sample-text' : 'Sample text for assessing subtitle font size',
    },
    about: {
        'cosy': 'Cooperative Systems',
        'faculty': 'Faculty of Computer Science',
        'uni': 'University of Vienna',
        'addr1': 'Währinger Straße 29/S6',
        'addr2': 'A-1090 Vienna',
        'copyright': '© 2021 Cooperative Systems (COSY) University of Vienna'
    },
    login: {
        'input-label': 'Please enter pin',
        'go-button': 'Enter',
        'incorrect-pin': 'Invalid pin'
    },
    hostlist: {
        'loading': 'Loading performances...',
        'no-hosts-available': 'There are currently no hosts with active performances.',
        'welcome-message': 'Welcome to opera.guru',
        'select-host': 'Please select your host:'
    }
};
